<template>
    <footer class="layout-footer sebrae-footer">
        <span class="sebrae-footer__brand">Portal de Serviços - SEBRAE-PE</span>
        <span class="sebrae-footer__version">v{{ versao }}</span>
        <span class="sebrae-footer__credit">
            Powered by
            <a href="https://sebrae.com.br/sites/PortalSebrae/" target="_blank" rel="noopener" class="sebrae-footer__link">SEBRAE PE - Sistemas</a>
        </span>
    </footer>
</template>

<script>
export default {
    name: 'AppFooter',
    data() {
        return {
            versao: process.env.VUE_APP_VERSION,
        };
    },
};
</script>

<style scoped>
.sebrae-footer {
    font-family: var(--sebrae-font-family-base);
    font-size: var(--sebrae-font-size-label);
    color: var(--sebrae-text-secondary);
    gap: var(--sebrae-space-3);
}

.sebrae-footer__version {
    font-weight: var(--sebrae-font-weight-semibold);
    color: var(--sebrae-text-label);
}

.sebrae-footer__link {
    color: var(--sebrae-primary);
    text-decoration: none;
}

.sebrae-footer__link:hover {
    text-decoration: underline;
}

@media (max-width: 414px) {
    .sebrae-footer__version {
        display: none;
    }
}
</style>
